"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSizes = void 0;
exports.fontSizes = {
    fontSize70: 11,
    fontSize80: 12,
    fontSize90: 14,
    fontSize100: 16,
    fontSize200: 18,
    fontSize300: 24,
    fontSize400: 32,
    fontSize500: 40,
    fontSize600: 64
};
